export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/decc719ac0c1523cc2040d71b927dcbc.svg";